import React from 'react';

const SigninPage = () => {
    return (
        <>
            <h1>Sign in page</h1>
        </>
    );
};

export default SigninPage;